<template>
  <div
    class="service-options"
    v-if="additionalOptions && additionalOptions.length"
  >
    <div
      :class="['service-option', disabled ? 'disabled' : null]"
      :key="opt.id"
      v-for="opt in groupOptions"
    >
      <label class="service-option-toggle switch">
        <input
          type="checkbox"
          @change.prevent="onChange($event, opt)"
          :checked="isSelected(opt) ? 'checked' : null"
          :disabled="disabled"
        />
        <span class="slider round"></span>
      </label>
      <div class="service-option-details">
        <label class="service-option-name font-bold">{{ opt.name }}</label>
        <div class="service-option-desc">{{ opt.description }}</div>
        <div class="service-option-price" v-if="opt.priceInEURCents > 0">
          {{ opt.priceInEURCents / 100 }}€
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import t from "@/services/translation-service";
import utils from "@/services/utils";

export default {
  name: "ServiceAdditionalOptions",

  props: {
    additionalOptions: Array,
    selectedOptions: Array,
    disabled: Boolean,
  },
  watch: {
    additionalOptions(newVal) {
      this.setGroupedOptions(newVal);
    },
  },
  methods: {
    isSelected(opt) {
      return this.selectedOptions.some((f) => opt.id === f.id);
    },
    onChange(event, option) {
      const newSelected = utils.clone(this.selectedOptions);
      option.groupOptions.map((opt) => {
        const index = newSelected.findIndex((item) => {
          return opt.id === item.id;
        });
        if (index < 0) {
          newSelected.push({ ...opt });
        } else {
          newSelected.splice(index, 1);
        }
      });
      this.$emit("change", newSelected);
    },
    getGroupKey(additionalOption) {
      return `${additionalOption.name}|${additionalOption.priceInEURCents}`;
    },
    getGrouped(additionalOptions) {
      const groups = additionalOptions?.reduce((acc, curr) => {
        const groupKey = this.getGroupKey(curr);
        if (acc.has(groupKey)) {
          acc.set(groupKey, [...acc.get(groupKey), curr]);
        } else {
          acc.set(groupKey, [curr]);
        }
        return acc;
      }, new Map());
      return groups;
    },
    setGroupedOptions(ops) {
      const groups = this.getGrouped(ops);
      const options = [...groups]?.map((optionGroup) => {
        const q = { ...optionGroup.at(1)[0] };
        q.groupOptions = optionGroup.at(1);
        return q;
      });
      this.groupOptions = options;
    },
  },
  data() {
    return {
      t: t,
      selected: [],
      groupedOptions: [],
    };
  },
  created() {
    this.setGroupedOptions(this.additionalOptions);
  },
};
</script>
<style scoped>
.service-options {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -1.5rem 2rem -1.5rem;
}
.service-option.disabled {
  color: gray;
  cursor: not-allowed;
}
.service-option {
  flex: 1 0 200px;
  margin-top: 20px;
  display: flex;
  padding: 0 1.5rem;
  flex-direction: row;
}
.service-option-toggle,
.service-option-details {
  flex-grow: 1;
  flex-basis: 50%;
}
.service-option-details {
  text-align: left;
  padding-left: 15px;
}

.service-price {
  font-weight: 900;
  font-size: 115%;
}
</style>
